import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import {NewellLogger} from "./logger.service";
import {NewellCookies} from "./cookie.service";
import {NewellLocalStorage} from "./local-storage.service";
import {NewellMemory} from "./memory.service";
import {NewellBreakpointObserver} from "./breakpoint";

const services = [
  NewellLogger,
  NewellCookies,
  NewellLocalStorage,
  NewellMemory,
  NewellBreakpointObserver,
]
@NgModule({
  imports: [ CommonModule ],
})
export class NewellCommonModule {
  static forRoot(): ModuleWithProviders<any> {
    return {
      ngModule: NewellCommonModule,
      providers: [...services ]
    };
  }
}
